/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect } from "react";
import { Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { statisticsSelector } from "../../../services/selector/index.";
import {
  IconNext,
  IconPolygon,
  IconPre,
  IconSortDown,
  IconSortUp,
  IconSpin,
} from "../../../assets/icon";
import "../../../assets/style/table/statistics.scss";
import { useMemo } from "react";
import TranslateText from "../TranslateText";
import { formatDate } from "../../../utils/functionCommon";
import { getDataStatisticsNews } from "../../../services/slice/statisticsSlice";

const TableStatistics = ({ type, valueSearch, setConfig, config }) => {
  const dispatch = useDispatch();
  const statisticsState = useSelector(statisticsSelector);
  const { dataSatisticsNews } = statisticsState;

  useEffect(() => {
    setConfig({
      ...config,
      search: valueSearch,
    });
  }, [valueSearch]);
  useEffect(() => {
    dispatch(getDataStatisticsNews(config));
  }, [config, dispatch]);
  const initFacebookSDK = () => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }

    let locale = "vi_VN";
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: window.REACT_APP_FACEBOOK_APP_ID,
        cookie: true, // enable cookies to allow the server to access
        // the session
        xfbml: true, // parse social plugins on this page
        version: "v2.5", // use version 2.1
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = `//connect.facebook.net/${locale}/sdk.js`;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };
  useEffect(() => {
    initFacebookSDK();
  }, []);

  const dataSource = useMemo(() => {
    const result = dataSatisticsNews?.data?.map((item, index) => {
      return {
        ...item,
        STT:
          dataSatisticsNews?.total > 10 && config.option.offset >= 2
            ? (config.option.offset - 1) * 10 + index + 1
            : index + 1,
        key: item.id,
        timeCreate: formatDate(item.timeCreate),
      };
    });
    return result;
  }, [dataSatisticsNews?.data, dataSatisticsNews?.total]);
  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "centerCell",
      ellipsis: {
        showTitle: false,
      },
      render: (name) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Thời gian tạo" />
          <div className="iconSort">
            <IconSortUp
              fill={
                config.typeSort === "timeCreate" &&
                config.option.order === "asc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  typeSort: "timeCreate",
                  option: { ...config.option, order: "asc" },
                })
              }
            />
            <IconSortDown
              fill={
                config.typeSort === "timeCreate" &&
                config.option.order === "desc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  typeSort: "timeCreate",
                  option: { ...config.option, order: "desc" },
                })
              }
            />
          </div>
        </div>
      ),
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "title collapseText centerCell",
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Số lượt xem" />
          <div className="iconSort">
            <IconSortUp
              fill={
                config.typeSort === "viewCount" && config.option.order === "asc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  typeSort: "viewCount",
                  option: { ...config.option, order: "asc" },
                })
              }
            />
            <IconSortDown
              fill={
                config.typeSort === "viewCount" &&
                config.option.order === "desc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  typeSort: "viewCount",
                  option: { ...config.option, order: "desc" },
                })
              }
            />
          </div>
        </div>
      ),
      dataIndex: "viewCount",
      key: "viewCount",
      className: "centerCell",
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Hiển thị" />
        </div>
      ),
      dataIndex: "numberNotify",
      key: "numberNotify",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Lượt comment" />,
      key: "comment",
      className: "centerCell",
      render: (_, record) => {
        return (
          // eslint-disable-next-line jsx-a11y/iframe-has-title
          <iframe
            className="countNumber"
            onLoad={<IconSpin className="iconSpin" />}
            src={`https://www.facebook.com/plugins/feedback.php?app_id=2113898809000323&channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df3f2ab244d28fa8%26domain%3Dmybkav.bkav.com%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fmybkav.bkav.com%252Ff105f199e7fae14%26relation%3Dparent.parent&container_width=600&height=100&locale=vi_VN&numposts=1&order_by=reverse_time&sdk=joey&version=v2.5&width&href=${
              window.URL_NEWS
            }${type === 1 ? "uu-dai" : "an-ninh"}?id=${record.guid}`}
          ></iframe>
        );
      },
    },
  ];
  const tableLoading = {
    spinning: false, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  const originalColumns = [...columns]; // Tạo bản sao của mảng cột

  const hiddenColumnKey = "numberNotify"; // key của cột cần loại bỏ

  // Lọc cột cần loại bỏ ra khỏi mảng cột
  const filteredColumns = originalColumns.filter(
    (column) => column.key !== hiddenColumnKey
  );

  return (
    <>
      <Row style={{ width: "100%" }}>
        <Table
          loading={tableLoading}
          className="wrapperTblStatistics"
          style={{ width: "100%", marginTop: "2.6rem" }}
          // columns={type === 2 ? filteredColumns : columns}
          columns={columns}
          dataSource={dataSource}
          pagination={
            dataSatisticsNews?.total > 10
              ? {
                  onChange: (value) => {
                    setConfig(() => ({
                      ...config,
                      option: {
                        ...config.option,
                        offset: value,
                      },
                    }));
                  },
                  current: config.option.offset,
                  defaultCurrent: config.option.offset,
                  total: dataSatisticsNews?.total,
                  pageSize: 10,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableStatistics;
